import React, { useEffect, useState } from 'react'
import { Card } from 'primereact/card';
import AppSettings from './../services/AppSettings';
import { useLocation, useParams } from 'react-router-dom';

const DonorFundManager = () => {
  const [iframeUrl, setIframeUrl] = useState('');
  const userid = window.sessionStorage.getItem('userid');

  const location = useLocation();
  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
      const params = new URLSearchParams(location.search);

      setQueryParams(params.get("Id") as any);
  }, [location]);
  const { Id } = useParams();
  const { orgID } = useParams();
  const { needtypeid } = useParams();

    // Assuming you have the required values for orgid, needtype, userid, and needid
    const orgid = orgID;
    const needtype = needtypeid; 
    const uid = userid;
    const needid = Id;

    // Create the URL
    // const url = `https://devreact.gearforneed.com/api/ws_ifdonation.php?orgid=${orgid}&userid=${uid}&needid=${needid}`;
    
    const  baseDomain = window.sessionStorage.getItem("baseDomain");
    const  Locationsurls = window.sessionStorage.getItem("Locationsurls");
    const url = `${baseDomain}/ws_ifdonation.php?orgid=${orgid}&userid=${Id}&needid=${needtypeid}&liveurl=${Locationsurls}`;

   
  console.log("url",url)
  //for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/donatedonor-needs.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };


  return (
    <div className="admin-layout-container">
        <div className="row">
    <div className="main-content">
    <div className="content-wrapper">
      <section className="content container-fluid">

          <div className="row justify-content-end mb-2">
            <div className="col-auto text-right">
              <a
                title="help"
                onClick={(e) => openWindow(e, IUrl)}
                style={{
                  color: "blue",
                  fontSize: 15,
                  cursor: "pointer"
                }}
              >
                Help for this Page &nbsp;
                <i
                  className="pi pi-question-circle"
                  style={{
                    backgroundColor: "orange",
                    color: "white",
                    padding: "4px",
                    borderRadius: "50%"
                  }}
                ></i>
              </a>
            </div>
          </div>

          <Card>
            <iframe
        title="Example iframe"
        width="100%"
        height="840px"
        src={url}
        frameBorder="0"
        allowFullScreen
        style={{top:0, left:0, bottom:0,right:0, border:'none', margin:0, padding:0, overflow:'hidden'}}
      />
          </Card>
      </section>
    </div>
    </div>
    </div>
    </div>
  )
}

export default DonorFundManager
